/**
 * O 8D do `RQ 002-04` (PLAN §9, fatia i).
 *
 * O formulário é o contrato: estes tipos descrevem o papel que a Qualidade e o
 * fornecedor já preenchem hoje, e não uma abstração de "tratamento de não
 * conformidade". Quando o `RQ 002-04` for revisado, é aqui que a mudança entra.
 */
// ---------------------------------------------------------------------------
// D2 — contenção
// ---------------------------------------------------------------------------
/**
 * Onde o material suspeito pode estar.
 *
 * Os três pontos do formulário, e a ordem importa: é a ordem do risco. O que já
 * está no cliente é o que para uma linha de montagem.
 */
export const ContainmentPlace = {
    CUSTOMER: 'CUSTOMER',
    TRANSIT: 'TRANSIT',
    SUPPLIER: 'SUPPLIER',
};
export const CONTAINMENT_PLACE_LABEL = {
    CUSTOMER: 'No cliente',
    TRANSIT: 'Em trânsito',
    SUPPLIER: 'No fornecedor',
};
// ---------------------------------------------------------------------------
// D6 — padronização
// ---------------------------------------------------------------------------
export const StandardizationItem = {
    FLOWCHART: 'FLOWCHART',
    PFMEA: 'PFMEA',
    CONTROL_PLAN: 'CONTROL_PLAN',
    WORK_INSTRUCTION: 'WORK_INSTRUCTION',
    PRODUCT_AUDIT: 'PRODUCT_AUDIT',
    OTHER: 'OTHER',
};
export const STANDARDIZATION_ITEM_LABEL = {
    FLOWCHART: 'Fluxograma',
    PFMEA: 'PFMEA',
    CONTROL_PLAN: 'Plano de Controle',
    WORK_INSTRUCTION: 'Instrução de Trabalho',
    PRODUCT_AUDIT: 'Auditoria de Produto',
    OTHER: 'Outros',
};
// ---------------------------------------------------------------------------
// O formulário
// ---------------------------------------------------------------------------
export const EightDStep = {
    D1: 'D1',
    D2: 'D2',
    D3: 'D3',
    D4: 'D4',
    D5: 'D5',
    D6: 'D6',
    D7: 'D7',
    D8: 'D8',
};
export const EIGHT_D_STEP_LABEL = {
    D1: 'D1 · O problema',
    D2: 'D2 · Contenção',
    D3: 'D3 · Equipe',
    D4: 'D4 · Causa raiz',
    D5: 'D5 · Ações',
    D6: 'D6 · Padronização',
    D7: 'D7 · Eficácia',
    D8: 'D8 · Encerramento',
};
/** Quantos porquês cada trilha do D4 tem. É o formulário que define. */
export const WHYS_PER_TRACK = 5;
/**
 * O que a foto do D1 mostra.
 *
 * "Aprovada" e "reprovada" lado a lado é o que torna a foto uma evidência: uma
 * sozinha mostra um defeito, duas mostram a diferença.
 */
export const RncAttachmentCategory = {
    APPROVED_SITUATION: 'APPROVED_SITUATION',
    REJECTED_SITUATION: 'REJECTED_SITUATION',
    OTHER: 'OTHER',
};
export const RNC_ATTACHMENT_CATEGORY_LABEL = {
    APPROVED_SITUATION: 'Situação aprovada',
    REJECTED_SITUATION: 'Situação reprovada',
    OTHER: 'Outro',
};
// ---------------------------------------------------------------------------
// Documentos do portal
// ---------------------------------------------------------------------------
export const PortalDocumentKind = {
    MANUAL: 'MANUAL',
    FORM: 'FORM',
    OTHER: 'OTHER',
};
export const PORTAL_DOCUMENT_KIND_LABEL = {
    MANUAL: 'Manual do Fornecedor',
    FORM: 'Formulários',
    OTHER: 'Outros documentos',
};
//# sourceMappingURL=eightd.js.map